import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const EMPTY_OBJECT: Record<string, any> = Object.freeze({});
const EMPTY_MAP: Record<string, any> = Object.freeze({});

/** Base slice selectors */
const selectLikedProductState = (state: RootState) => state.likedProduct;
const selectProductsState = (state: RootState) => state.products;
const selectProductsTypeState = (state: RootState) => state.productsType;

const selectMappedImagesByProductId = createSelector(
  [(state: RootState) => selectProductsState(state).imagesByMaterialForHomePage ?? EMPTY_OBJECT],
  (imagesByMaterialForHomePage) => {
    const entries = Object.entries(imagesByMaterialForHomePage);
    if (entries.length === 0) return EMPTY_MAP;

    const mapped: Record<string, string[]> = {};
    for (const [productId, entry] of entries as [string, any][]) {
      mapped[productId] = entry?.images ?? [];
    }
    return mapped;
  }
);

export const makeSelectProductImagesByProductId = (pathname: string) =>
  (state: RootState) => {
    if (pathname === '/product/liked') {
      return selectLikedProductState(state).productImagesByProductId ?? EMPTY_OBJECT;
    }
    if (pathname.startsWith('/products/types/')) {
      return selectProductsTypeState(state).productImagesByProductId ?? EMPTY_OBJECT;
    }
    return selectMappedImagesByProductId(state);
  };

export const makeSelectMaterialIconsByProductId = (pathname: string) =>
  (state: RootState) => {
    if (pathname.includes('/liked')) {
      return selectLikedProductState(state).materialIconsByProductId ?? EMPTY_OBJECT;
    }
    if (pathname.startsWith('/products/types/')) {
      return selectProductsTypeState(state).materialIconsByProductId ?? EMPTY_OBJECT;
    }
    return selectProductsState(state).materialIconsByProductId ?? EMPTY_OBJECT;
  };

export const makeSelectImageStatusByProductId = (pathname: string) =>
  (state: RootState) => {
    if (pathname.includes('/liked')) {
      return selectLikedProductState(state).statusByProductId ?? EMPTY_OBJECT;
    }
    if (pathname.startsWith('/products/types/')) {
      return selectProductsTypeState(state).statusByProductId ?? EMPTY_OBJECT;
    }
    return selectProductsState(state).statusByProductId ?? EMPTY_OBJECT;
  };

export const makeSelectImageErrorByProductId = (pathname: string) =>
  (state: RootState) => {
    if (pathname.includes('/liked')) {
      return selectLikedProductState(state).errorByProductId ?? EMPTY_OBJECT;
    }
    if (pathname.startsWith('/products/types/')) {
      return selectProductsTypeState(state).errorByProductId ?? EMPTY_OBJECT;
    }
    return selectProductsState(state).errorByProductId ?? EMPTY_OBJECT;
  };
